export default {
	home: {
		name: ""
	}
};
